import React, { useContext } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Quickbar from "../layouts/Quickbar";
import Customerlistcontent from "../sections/Customer-list/Customerlistcontent";
import AuthContext from "../../context/auth-context";

export const Customerlist = (props) => {
  const ctx = useContext(AuthContext);
  return (
    <div
      className={
        ctx.darkMode
          ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
          : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
      }
    >
      <Sidenavigation />
      <main className="body-content">
        <Topnavigation />
        <Customerlistcontent />
      </main>
      <Quickbar />
    </div>
  );
};

export default Customerlist;
